import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { CommonService } from 'src/app/core/services/common.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  submitted = false;
  isGoogleAuthenticatorRegistered: boolean = false;
  barcodeImageUrl: string = '';
  isShowAuthenticator: boolean = false;
  getuserAuthentication: any = [];
  orgAppID: any;
  otpPromptMessage: string = '';
  authenticationUniqueCode: string = '';
  url: any;
  imageURL!: Observable<string>;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private loader: LoaderService,
    private restService: RestService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private route: ActivatedRoute,
    public router: Router,
    private errorHandler: ErrorHandlerService,
    private commonService: CommonService) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['kamarajPrakash@swiftant.com', [Validators.required, Validators.pattern(/^\s*[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\s*$/)]],
      password: ['Password@123', Validators.required]
    })
    this.route.queryParams.subscribe(params => {
      this.url = params['redirect_url'];
    });
  }

  get control() {
    return this.loginForm.controls
  }

  login() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    let params = {
      emailID: this.control['username'].value.trim(),
      password: this.control['password'].value
    }

    this.loader.show();
    this.restService.postUATData(params, 'api/digital/core/Account/Login').subscribe({
      next: (data: any) => {
        try {
          if (data.rcode == 200) {
            this.authService.saveRefreshToken(data.rObj.refreshToken);
            this.authService.b2cAttemptAuth(data.rObj.token);
            const encryptedValue = CryptoJS.AES.encrypt(data.rObj.token, 'your_secret_key').toString();
            const domain = '.insure.digital'; // Set for root domain
            const domain1 = '.swiftant.com'; // Set for root domain

            this.cookieService.set('JWTtoken', encryptedValue, undefined, '/', domain, false, 'Strict');
            // this.cookieService.set('Uad-Token', encryptedValue, undefined, '/', domain, false, 'Strict');
            this.cookieService.set('JWTtoken', encryptedValue, undefined, '/', domain1, false, 'Strict');
            // this.cookieService.set('Uad-Token', encryptedValue, undefined, '/', domain1, false, 'Strict');

            // Additionally, set cookie for localhost
            this.cookieService.set('JWTtoken', encryptedValue, undefined, '/', 'localhost', false, 'Strict');
            // this.cookieService.set('Uad-Token', encryptedValue, undefined, '/', 'localhost', false, 'Strict');
            //  window.location.href =this.reDirectUrl

            if (this.url) {
              const decodedUrl = decodeURIComponent(this.url);
              window.location.href = decodedUrl; // Redirect to the decoded URL
            } else {
              this.router.navigate(['/home']);
            }
          }
          else if (data.rcode == 203) {
            this.isGoogleAuthenticatorRegistered = data.rObj.isGoogleAuthenticatorRegistered;
            this.barcodeImageUrl = data.rObj.barcodeImageUrl;
            this.getuserAuthentication = data.rObj.fetchUserLoginAuthenticationDetails;
            this.isShowAuthenticator = true;
            this.otpPromptMessage = data.rObj.message;
            this.authenticationUniqueCode = data.rObj.authenticationUniqueCode;
          }
          else{
            this.errorHandler.handleRcodeError(data);
          }
        } catch (error) {
          this.errorHandler.internalError();
        } finally {
          this.loader.hide();
        }
      },
      error: (error: any) => {
        this.loader.hide();
        this.errorHandler.handleStatusError(error);
      }
    })
  }
}
